import React from "react";
import { Button } from "antd";
import notifyIcon from "../../images/notifyIcon.svg";
import updateIcon from "../../images/updatesIcon.svg";
import developerIcon from "../../images/developerIcon.svg";
import gencSnacksIcon from "../../images/gencSnacks.svg";
export const Subscriptions = ({
  handleSampleNotif,
  handleMemberSub,
  handleLatestUpdate,
  handleShareholderSub,
  handleLatestNews,
  handleNewsSub,
  handleLatestSnacks,
  handleSnacksSub,
}) => {
  return (
    <section
      // data-aos="fade-down-left"
      id="subscriptions"
      className="content-2 "
    >
      <div className="row" style={{ margin: "unset" }}>
        <div
          className="col-lg-3 col-md-6 col-sm-6 col-xs-12 continfobox"
          id="list-box-3"
          data-tags="technology politics business entertainment lifestyle"
          data-aos="fade-left"
          data-aos-delay="250"
        >
          <div className="infobox text-center">
            <div className="flip-container ">
              <div className="flipper">
                <div className="front">
                  <figure className="col-lg-5 col-md-5 col-sm-12 col-xs-12 img-circle">
                    <img alt="member notifs" src={notifyIcon} />
                  </figure>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 info">
                    <h3>
                      <a href="/daily">Member Notifications</a>
                    </h3>
                    <p>
                      Members subcribe to GenC Health Notifications for updates
                      about the latest membership info, GenC Health-Box new
                      features, available apps and models.
                    </p>
                    <p>
                      <a
                        onClick={handleSampleNotif}
                        className="orange underlined"
                        href="/campaigns/inside-daily-brief-2020-08-03-23967"
                      >
                        <strong>
                          <u>Sample notifications</u>
                        </strong>
                      </a>
                    </p>
                    <div className="tags">
                      <b>ASAP</b>
                    </div>
                  </div>
                  <div className="list-subscription-action">
                    <Button
                      data-remote="true"
                      data-disable-with="Opening ..."
                      className="col-xs-12 btn btn-default btn-susbcr"
                      onClick={handleMemberSub}
                    >
                      <i className="fa fa-envelope ico ico-env" /> Subscribe
                      <img
                        className="ico ico-arrow"
                        src="https://inside.com//assets/web/ico-arrow-gray-ccce20fba87a4b789849696785ba3840e240aaf30233bba4668f82b3309787ae.png"
                        alt="Ico arrow gray"
                      />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-lg-3 col-md-6 col-sm-6 col-xs-12 continfobox"
          id="list-box-3"
          data-aos="fade-left"
          data-aos-delay="500"
          data-tags="technology politics business entertainment lifestyle"
        >
          <div className="infobox text-center">
            <div className="flip-container ">
              <div className="flipper">
                <div className="front">
                  <figure className="col-lg-5 col-md-5 col-sm-12 col-xs-12 img-circle">
                    <img alt="GenC Updates " src={updateIcon} />
                  </figure>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 info">
                    <h3>
                      <a href="/daily">GenC Labs Inc. Updates</a>
                    </h3>
                    <p>
                      Shareholders subscribe to GenC Labs Inc. newsletter for
                      press releases, GenC platform development milestones, and
                      corporate news.
                    </p>
                    <p>
                      <a
                        onClick={handleLatestUpdate}
                        className="orange underlined"
                        href="/campaigns/inside-daily-brief-2020-08-03-23967"
                      >
                        <strong>
                          <u>Latest update</u>
                        </strong>
                      </a>
                    </p>
                    <div className="tags">
                      <b>WEEKLY</b>
                    </div>
                  </div>
                  <div className="list-subscription-action">
                    <Button
                      data-remote="true"
                      data-disable-with="Opening ..."
                      className="col-xs-12 btn btn-default btn-susbcr"
                      onClick={handleShareholderSub}
                    >
                      <i className="fa fa-envelope ico ico-env" /> Subscribe
                      <img
                        className="ico ico-arrow"
                        src="https://inside.com//assets/web/ico-arrow-gray-ccce20fba87a4b789849696785ba3840e240aaf30233bba4668f82b3309787ae.png"
                        alt="Ico arrow gray"
                      />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-lg-3 col-md-6 col-sm-6 col-xs-12 continfobox"
          id="list-box-3"
          data-tags="technology politics business entertainment lifestyle"
          data-aos="fade-left"
          data-aos-delay="750"
        >
          <div className="infobox text-center">
            <div className="flip-container ">
              <div className="flipper">
                <div className="front">
                  <figure className="col-lg-5 col-md-5 col-sm-12 col-xs-12 img-circle">
                    <img alt="Developer newsletter" src={developerIcon} />
                  </figure>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 info">
                    <h3>
                      <a href="/daily">Developer Newsletter</a>
                    </h3>
                    <p>
                      Developers subscribe to GenC App Store and ML Model
                      related tutorials, software development training, and job
                      opportunities.
                    </p>
                    <p>
                      <a
                        onClick={handleLatestNews}
                        className="orange underlined"
                        href="/campaigns/inside-daily-brief-2020-08-03-23967"
                      >
                        <strong>
                          <u>Latest issue</u>
                        </strong>
                      </a>
                    </p>
                    <div className="tags">
                      <b>WEEKLY</b>
                    </div>
                  </div>
                  <div className="list-subscription-action">
                    <Button
                      data-remote="true"
                      data-disable-with="Opening ..."
                      className="col-xs-12 btn btn-default btn-susbcr"
                      onClick={handleNewsSub}
                    >
                      <i className="fa fa-envelope ico ico-env" /> Subscribe
                      <img
                        className="ico ico-arrow"
                        src="https://inside.com//assets/web/ico-arrow-gray-ccce20fba87a4b789849696785ba3840e240aaf30233bba4668f82b3309787ae.png"
                        alt="Ico arrow gray"
                      />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6 col-sm-6 col-xs-12 continfobox"
          id="list-box-3"
          data-tags="technology politics business entertainment lifestyle"
          data-aos="fade-left"
          data-aos-delay="1000"
        >
          <div className="infobox text-center">
            <div className="flip-container ">
              <div className="flipper">
                <div className="front">
                  <figure className="col-lg-5 col-md-5 col-sm-12 col-xs-12 img-circle">
                    <img alt="GenC Snacks Newsletter" src={gencSnacksIcon} />
                  </figure>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 info">
                    <h3>
                      <a href="/daily">GenC Snacks</a>
                    </h3>
                    <p>
                      The 3-minute newsletter with fresh takes on the health,
                      fitness, healthcare, and health-tech news you need to
                      start your day.
                    </p>
                    <p>
                      <a
                        onClick={handleLatestSnacks}
                        className="orange underlined"
                        href="/campaigns/inside-daily-brief-2020-08-03-23967"
                      >
                        <strong>
                          <u>Latest issue</u>
                        </strong>
                      </a>
                    </p>
                    <div className="tags">
                      <b>DAILY</b>
                    </div>
                  </div>
                  <div className="list-subscription-action">
                    <Button
                      data-remote="true"
                      data-disable-with="Opening ..."
                      className="col-xs-12 btn btn-default btn-susbcr"
                      onClick={handleSnacksSub}
                    >
                      <i className="fa fa-envelope ico ico-env" /> Subscribe
                      <img
                        className="ico ico-arrow"
                        src="https://inside.com//assets/web/ico-arrow-gray-ccce20fba87a4b789849696785ba3840e240aaf30233bba4668f82b3309787ae.png"
                        alt="Ico arrow gray"
                      />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
